import { render, staticRenderFns } from "./InputTextarea.vue?vue&type=template&id=1090944d&scoped=true"
import script from "./InputTextarea.vue?vue&type=script&lang=ts"
export * from "./InputTextarea.vue?vue&type=script&lang=ts"
import style0 from "./InputTextarea.vue?vue&type=style&index=0&id=1090944d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1090944d",
  null
  
)

export default component.exports